import { useQuery } from '@tanstack/react-query';

import { useHttpClient } from '@bonusly/http-client';

import { Incentive } from '../types/incentives';

const QueryKey = {
	IncentivesSummary: 'incentives-summary',
};

export interface Award {
	id: string;
	name: string;
}
export interface GetIncentivesSummaryParams {
	award_ids: string[];
	end_date: string;
	page_number: number;
	page_size: number;
	sort_order: 'asc' | 'desc';
	start_date: string;
}

interface GetIncentivesSummaryResponse {
	result: {
		awards: Award[];
		claims: Incentive[];
		pagination: {
			page_count: number;
			page_next?: number;
			page_number: number;
			page_previous?: number;
			page_size: number;
			total_count: number;
		};
	};
}

export const useGetIncentivesSummary = (params: GetIncentivesSummaryParams) => {
	const http = useHttpClient('v2');
	return useQuery(
		[QueryKey.IncentivesSummary, params],
		() => {
			return http.get<GetIncentivesSummaryResponse>('/admin/incentives/summary', { params });
		},
		{
			retry: false,
			refetchOnWindowFocus: false,
			select: (data) => {
				return data.data.result;
			},
		}
	);
};
